var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInscrever = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46038 5.71429C9.46038 5.82812 9.4202 5.93527 9.33984 6.01562L8.73047 6.625L6.30636 9.04911C6.226 9.12946 6.11886 9.16964 6.00502 9.16964C5.89118 9.16964 5.78404 9.12946 5.70368 9.04911L5.09431 8.43973C5.01395 8.35938 4.96708 8.25223 4.96708 8.13839C4.96708 8.02455 5.01395 7.91741 5.09431 7.83705L6.35993 6.57143H2.99833C2.76395 6.57143 2.56975 6.37723 2.56975 6.14286V5.28571C2.56975 5.05134 2.76395 4.85714 2.99833 4.85714H6.35993L5.09431 3.59152C5.01395 3.51116 4.97377 3.40402 4.97377 3.29018C4.97377 3.17634 5.01395 3.0692 5.09431 2.98884L5.70368 2.37946C5.78404 2.29911 5.89118 2.25893 6.00502 2.25893C6.11886 2.25893 6.226 2.29911 6.30636 2.37946L8.73047 4.80357L9.33984 5.41295C9.4202 5.4933 9.46038 5.60045 9.46038 5.71429ZM11.1412 5.71429C11.1412 2.875 8.83761 0.571428 5.99833 0.571428C3.15904 0.571428 0.855469 2.875 0.855469 5.71429C0.855469 8.55357 3.15904 10.8571 5.99833 10.8571C8.83761 10.8571 11.1412 8.55357 11.1412 5.71429Z",
    fill: "#CE2D50"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInscrever, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/inscrever.c7cd0197.svg";
export { ForwardRef as ReactComponent };